<template>
  <!--<div class="container bg">
    <div class="row" style="margin-top:30px">
      <div class="col-md-10 pb">
        <div>
          <h3>Maturity Report</h3>
          <canvas id="printMaturity"></canvas>
        </div>
      </div>
      <div class="col-md-10 pb pagebreak">
        <div>
          <h3>Insured/Uninsured Report</h3>
          <canvas id="printInsured"></canvas>
        </div>
      </div>
      <div class="col-md-10 pb">
        <div>
          <h3>Moody's Rating Report</h3>
          <canvas id="printMoody"></canvas>
        </div>
      </div>
      <div class="col-md-10 pb">
        <div>
          <h3>S&P Rating Report</h3>
          <canvas id="printSP"></canvas>
        </div>
      </div>
      <div class="col-md-10 pb pagebreak">
        <div>
          <h3>State Report</h3>
          <canvas id="printState"></canvas>
        </div>
      </div>
      <div class="col-md-10 pb">
        <div>
          <h3>Insurance Report</h3>
          <canvas id="printInsurance"></canvas>
        </div>
      </div>
      <div class="col-md-10 pb pagebreak mb">
        <div style="height:550px">
          <h3>Purpose Report</h3>
          <canvas id="printPurpose"></canvas>
        </div>
      </div>
      <div class="col-md-10 pb">
        <div>
          <h3>Coupon Report</h3>
          <canvas id="printCoupon"></canvas>
        </div>
      </div>
      <div class="col-md-10 pb pagebreak">
        <div>
          <h3>Call Date Report</h3>
          <canvas id="printCall"></canvas>
        </div>
      </div>
    </div>
  </div>-->
  <div class="wrap">
    <button onclick="javascript:window.print()" class="btn-print">
      <i class="fas fa-print"></i> Print PDF
    </button>
    <div class="printHeadLogo">
      <img src="https://bidside-logos.s3.amazonaws.com/Drl.png"  class="navbar-brand-img" />
    </div>
    <h2 class="mb-4">DRL Group {{this.maturitySell ? "Sell" : "Buy"}} Activity </h2>    
    <div class="dateRange">
      <span>From: <p>{{changeDateFormat(this.fromdate)}}</p></span>
      <span>To: <p>{{changeDateFormat(this.todate)}}</p></span>
      <span>Trading Option: <p>{{this.maturitySell ? "Sell" : "Buy"}}</p></span>
    </div>
    <div class="graphWrap">
      <span class="title">Maturity Report</span>
      <canvas id="printMaturity"></canvas>
    </div>
    <div class="graphWrap">
      <span class="title">Insured/Uninsured Report</span>
      <canvas id="printInsured"></canvas>
    </div>
    <div class="page-brake"></div>
    <div class="graphWrap">
      <span class="title">Moody's Rating Report</span>
      <canvas id="printMoody"></canvas>
    </div>
    <div class="graphWrap">
      <span class="title">S&P Rating Report</span>
      <canvas id="printSP"></canvas>
    </div>
    <div class="page-brake"><img src="https://bidside-logos.s3.amazonaws.com/print_logo.png"  class="navbar-brand-img" /></div>
    <div class="graphWrap">
      <span class="title">State Report</span>
      <!-- <canvas id="printState"></canvas> -->
      <div id="regions_div"></div>
    </div>
    <div class="graphWrap">
      <span class="title">Insurance Report</span>
      <canvas id="printInsurance"></canvas>
    </div>
    <!-- <div class="page-brake"><img src="https://bidside-logos.s3.amazonaws.com/print_logo.png"  class="navbar-brand-img" /></div>
    <div class="graphWrap">
      <span class="title">Purpose Report</span>
      <div id="chart_div" style="height: 670px "></div>
    </div> -->
    <div class="page-brake"><img src="https://bidside-logos.s3.amazonaws.com/print_logo.png"  class="navbar-brand-img" /></div>
    <div class="graphWrap">
      <span class="title">Coupon Report</span>
      <canvas id="printCoupon"></canvas>
    </div>
    <div class="graphWrap">
      <span class="title">Call Date Report</span>
      <canvas id="printCall"></canvas>
    </div>
    <div class="disclaimer">
      Securities offered through NewEdge Securities, LLC, member FINRA and SIPC. The DRL Group is not a subsidiary or control affiliate of NewEdge Securities, LLC. NewEdge Securities, Inc. has no affiliation to BondDesk Trading LLC or BondTrader Pro, or Tradeweb Direct, Bondpoint, TMC, Market Axess or any ECN.<br><br>
      Do not buy discount bonds based on the Yield-to-Call (YTC). Yield to call (YTC) is not indicative of total return; this yield is valid only if the security is called. Bonds may or may not be called, or be callable on multiple dates or, in other cases, called any date following the first call date, so yield to call is based on the earliest stated call date. Discounted bonds may be subject to capital gains tax. Bonds may be subject to OID (Original Issue Discount). Bonds could also be subject to the DeMinimis Rule, please consult your tax advisor for further clarification. Insured bonds are issued for timely payment of principal and interest only. Insured bonds do not cover potential market loss and are subject to the claims paying ability of the insurance company. Municipal income may be subject to state, local, and Alternative Minimum Tax (AMT) taxation. Corporate and Municipal securities are subject to gains/losses based on the level of interest rates, market conditions, and credit quality of the issuer. Non-rated (NR), With-Drawn (WR), or below investment grade bonds, and lower-rated bonds carry a greater potential risk of default and should be considered by sophisticated investors only.<br><br>
      Prices and availability may change at any time without notice. The securities described herein may not be eligible for sale in all jurisdictions or to specific categories of investors.<br><br>
      This summary is for informational purposes only and is not an offer or solicitation for the purchase or sale of any security or a recommendation or endorsement of any security or issuer. NewEdge Securities, LLC. and DRL Group make no representation about the accuracy, completeness, or timeliness of this information.<br><br>
      This report does not regard any recipient's specific investment objectives, financial situation, or needs and is based on information obtained from sources believed to be reliable. No independent verification has been made, nor is its accuracy or completeness guaranteed. Opinions expressed herein are subject to change without notice. The division, group, subsidiary, or affiliate of NewEdge Securities, LLC, is under no obligation to update or keep the information current. NewEdge Securities, LLC accepts no liability for any loss or damage of any kind arising out of the use of this report. Contact your tax advisor regarding the suitability of tax-exempt investments in your portfolio. This document is for informational purposes only and does not replace or serve as a substitute for your official monthly statement generated by NFS. Please refer to your official statement for accurate and comprehensive account details.<br><br>
      Reminder: E-mails sent through the internet are not secure. Do not use e-mail to send us personal confidential information. Do not e-mail time sensitive instructions or trade orders. This e-mail is not an official trade confirmation for transactions executed in your account. Your e-mail message is not private; it is subject to review by the firm, its officers, agents, and employees. Unless expressly stated in this e-mail, nothing in this message should be construed as a digital or electronic signature.</div>      
    <div class="page-brake"><img src="https://bidside-logos.s3.amazonaws.com/print_logo.png"  class="navbar-brand-img" /></div>
  </div>
</template>
<script>
//import this.$http from "this.$http";
import config from "@/config";
import chartConstants from "@/chartConstants";
//import Chart from "chart.js";
//import { topojson } from "chartjs-chart-geo";
import { GoogleCharts } from "google-charts";
import stateConstants from "@/stateConstants";

export default {
  data() {
    return {
      accessToken: null,
      fromdate: "",
      todate: "",
      maturitySell: false,
      insuredBuyOrSell: false,
      moodyBuyOrSell: false,
      SPBuyOrSell: false,
      stateBuyOrSell: false,
      insuranceBuyOrSell: false,
      purposeBuyOrSell: false,
      couponBuyOrSell: false,
      callBuyOrSell: false,
      maturityChartOptions: chartConstants.maturityBarChartDefaultPopup,
      maturityChartData: {},
      insuredChartOptions: chartConstants.pieChartDefaultPopup,
      insuredChartData: {},
      moodyChartOptions: chartConstants.ratingBarChartDefaultPopup,
      moodyChartData: {},
      SPChartOptions: chartConstants.spRatingBarChartDefaultPopup,
      SPChartData: {},
      stateChartOptions: chartConstants.geoMapDefaultPopUp,
      stateChartData: {},
      insuranceChartOptions: chartConstants.insuranceChartDefaultPopup,
      insuranceChartData: {},
      purposeChartOptions: chartConstants.purposeChartDefaultPopup,
      purposeChartData: {},
      couponChartOptions: chartConstants.couponBarChartDefaultPopup,
      couponChartData: {},
      callChartDataOptions: chartConstants.callChartDefault,
      callChartData: {},
      stateConstants: stateConstants

      //myChartPoup: null
    };
  },
  methods: {
    getPopupMaturityReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/maturity-date?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          console.log(typeof this.maturitySell);
          this.maturityChartData = result.data.data;
          this.maturityChartOptions.data.labels = this.maturityChartData.years;
          this.maturityChartOptions.data.datasets[0].data = this.maturitySell
            ? this.maturityChartData.sells
            : this.maturityChartData.buys;
          // if (this.myChartPoup) {
          //   this.myChartPoup.destroy();
          // }
          const ctx = document.getElementById("printMaturity");
          new window.Chart(ctx, {
            type: this.maturityChartOptions.type,
            data: this.maturityChartOptions.data,
            options: this.maturityChartOptions.options
          });
        });
    },
    getInsuredReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/insured?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.insuredChartData = result.data.data;
          this.insuredChartOptions.data.labels = this.insuredBuyOrSell
            ? this.insuredChartData.sellsLabels
            : this.insuredChartData.buysLabels;
          this.insuredChartOptions.data.datasets[0].data = this.insuredBuyOrSell
            ? this.insuredChartData.sells
            : this.insuredChartData.buys;
          const ctx = document.getElementById("printInsured");
          new window.Chart(ctx, {
            type: this.insuredChartOptions.type,
            data: this.insuredChartOptions.data,
            //== plugins: [ChartDataLabels],
            options: this.insuredChartOptions.options
          });
        });
    },
    getMoodyRatingReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/rating?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false&ratingsType=moodys",
          auth
        )
        .then(result => {
          this.moodyChartData = result.data.data;
          this.moodyChartOptions.data.labels = this.moodyBuyOrSell
            ? this.moodyChartData.sellsRatings
            : this.moodyChartData.buysRatings;
          this.moodyChartOptions.data.datasets[0].data = this.moodyBuyOrSell
            ? this.moodyChartData.sells
            : this.moodyChartData.buys;
          var ctx = document.getElementById("printMoody");
          new window.Chart(ctx, {
            type: this.moodyChartOptions.type,
            data: this.moodyChartOptions.data,
            options: this.moodyChartOptions.options
          });
        });
    },
    getSPRatingReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/rating?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false&ratingsType=SandP",
          auth
        )
        .then(result => {
          this.SPChartData = result.data.data;
          this.SPChartOptions.data.labels = this.SPBuyOrSell
            ? this.SPChartData.sellsRatings
            : this.SPChartData.buysRatings;
          this.SPChartOptions.data.datasets[0].data = this.SPBuyOrSell
            ? this.SPChartData.sells
            : this.SPChartData.buys;
          const ctx = document.getElementById("printSP");
          new window.Chart(ctx, {
            type: this.SPChartOptions.type,
            data: this.SPChartOptions.data,
            options: this.SPChartOptions.options
          });
        });
    },
    getStateReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/state?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.stateChartData = result.data.data;
          var stateArray = [];
          stateArray = [["State", "Select"]];
          for (let i = 0; i < this.stateConstants.length; i++) {
            var dataSet = [
              this.stateConstants[i].name,
              this.getCusipCountPerStatePopUp(this.stateConstants[i].name)
            ];
            stateArray.push(dataSet);
          }
          var data = GoogleCharts.api.visualization.arrayToDataTable(
            stateArray
          );
          var options = {
            region: "US",
            displayMode: "regions",
            resolution: "provinces",
            colorAxis: { colors: ["#FF0000", "#FFA500", "#008000"] }
          };
          var chart = new GoogleCharts.api.visualization.GeoChart(
            document.getElementById("regions_div")
          );
          chart.draw(data, options);
        });
    },
    getCusipCountPerStatePopUp(state) {
      let stateObj;
      if (this.stateBuyOrSell) {
        stateObj = this.stateChartData.sells.find(
          element => state == Object.keys(element)[0]
        );
      } else {
        stateObj = this.stateChartData.buys.find(
          element => state == Object.keys(element)[0]
        );
      }
      if (stateObj) {
        return stateObj[Object.keys(stateObj)[0]] || 0;
      } else {
        return 0;
      }
    },
    getInsuranceReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/insurer?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.insuranceChartData = result.data.data;
          this.insuranceChartOptions.data.labels = this.insuranceBuyOrSell
            ? this.insuranceChartData.sellsInsurers
            : this.insuranceChartData.buysInsurers;
          this.insuranceChartOptions.data.datasets[0].data = this
            .insuranceBuyOrSell
            ? this.insuranceChartData.sells
            : this.insuranceChartData.buys;
          const ctx = document.getElementById("printInsurance");
          new window.Chart(ctx, {
            type: this.insuranceChartOptions.type,
            data: this.insuranceChartOptions.data,
            options: this.insuranceChartOptions.options
          });
        });
    },
    getPurposeReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/purpose?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.purposeChartData = result.data.data;
          var self = this;
          this.purposeChartOptions.data.datasets[0].tree = this.purposeBuyOrSell
            ? this.purposeChartData.sells
            : this.purposeChartData.buys;
          this.purposeChartOptions.data.datasets[0].backgroundColor = function(
            ctx
          ) {
            if (ctx.dataset.data.length <= ctx.dataIndex) {
              return undefined;
            }
            return self.colorFromValue(ctx.dataset.data[ctx.dataIndex].v);
          };
          const ctx = document.getElementById("printPurpose");
          new window.Chart(ctx, {
            type: this.purposeChartOptions.type,
            data: this.purposeChartOptions.data,
            options: this.purposeChartOptions.options
          });
        });
    },
    colorFromValue(value, border) {
      var alpha = (1 + Math.log(value)) / 5;
      var color = "#2959B5";
      if (border) {
        alpha += 0.01;
      }
      return window.chart.helpers
        .color(color)
        .alpha(alpha)
        .rgbString();
    },
    getPurposeReportDataWithGChart() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/purpose?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.purposeChartData = result.data.data;
          var getDatafromResult = [
            ["Location", "Parent", "count"],
            ["Purpose", null, 0]
          ];
          var dataArray = [];
          dataArray = this.purposeBuyOrSell
            ? this.purposeChartData.sells
            : this.purposeChartData.buys;
          for (let i = 0; i < dataArray.length; i++) {
            var dataSet = [dataArray[i].label, "Purpose", dataArray[i].count];
            getDatafromResult.push(dataSet);
          }
          var data = GoogleCharts.api.visualization.arrayToDataTable(
            getDatafromResult
          );
          var tree = new GoogleCharts.api.visualization.TreeMap(
            document.getElementById("chart_div")
          );
          new GoogleCharts.api.visualization.events.addListener(
            tree,
            "select",
            function() {
              tree.setSelection([]);
            }
          );
          tree.draw(data, {
            minColor: "#FF0000",
            midColor: "#FFA500",
            maxColor: "#008000",
            headerHeight: 15,
            fontColor: "black",
            generateTooltip: showFullTooltip,
            showScale: true
          });
          function showFullTooltip(row) {
            //console.log("in tooltip 1");
            return (
              '<div style="background:#fd9; padding:10px; border-style:solid">' +
              '<span style="font-family:Courier"><b>' +
              data.getValue(row, 2) +
              "</b></span></div>"
            );
          }
          //var self = this;
          // this.purposeChartOptions.data.datasets[0].tree = this.purposeBuyOrSell
          //   ? this.purposeChartData.sells
          //   : this.purposeChartData.buys;
          // this.purposeChartOptions.data.datasets[0].backgroundColor = function(
          //   ctx
          // ) {
          //   if (ctx.dataset.data.length <= ctx.dataIndex) {
          //     return undefined;
          //   }
          //   return self.colorFromValue(ctx.dataset.data[ctx.dataIndex].v);
          // };
          // const ctx = document.getElementById("printPurpose");
          // new window.Chart(ctx, {
          //   type: this.purposeChartOptions.type,
          //   data: this.purposeChartOptions.data,
          //   options: this.purposeChartOptions.options
          // });
        });
    },
    getCouponReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/coupon?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.couponChartData = result.data.data;
          this.couponChartOptions.data.labels = this.couponBuyOrSell
            ? this.couponChartData.sellsLabels
            : this.couponChartData.buysLabels;
          this.couponChartOptions.data.datasets[0].data = this.couponBuyOrSell
            ? this.couponChartData.sells
            : this.couponChartData.buys;

          const ctx = document.getElementById("printCoupon");
          new window.Chart(ctx, {
            type: this.couponChartOptions.type,
            data: this.couponChartOptions.data,
            options: this.couponChartOptions.options
          });
        });
    },
    getCallReportData() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(
          config.baseUrl +
            "/report/call-date?fromDate=" +
            this.fromdate +
            "&toDate=" +
            this.todate +
            "&dashboard=false",
          auth
        )
        .then(result => {
          this.callChartData = result.data.data;
          this.callChartDataOptions.data.labels = this.callBuyOrSell
            ? this.callChartData.sellsLabels
            : this.callChartData.buysLabels;
          this.callChartDataOptions.data.datasets[0].data = this.callBuyOrSell
            ? this.callChartData.sells
            : this.callChartData.buys;
          const ctx = document.getElementById("printCall");
          new window.Chart(ctx, {
            type: this.callChartDataOptions.type,
            data: this.callChartDataOptions.data,
            options: this.callChartDataOptions.options
          });
        });
    },
    changeDateFormat(currectDate){

      var dateObjArray = currectDate.split('-');
      return dateObjArray[1]+"-"+dateObjArray[2]+"-"+dateObjArray[0];
       

    }
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        var url_string = window.location.href;
        var url = new URL(url_string);
        this.fromdate = url.searchParams.get("fromDate");
        this.todate = url.searchParams.get("toDate");
        this.maturitySell =
          url.searchParams.get("isSell") == "true" ? true : false;
        this.insuredBuyOrSell =
          url.searchParams.get("isSell") == "true" ? true : false;
        this.moodyBuyOrSell =
          url.searchParams.get("isSell") == "true" ? true : false;
        this.SPBuyOrSell =
          url.searchParams.get("isSell") == "true" ? true : false;
        this.stateBuyOrSell =
          url.searchParams.get("isSell") == "true" ? true : false;
        this.insuranceBuyOrSell =
          url.searchParams.get("isSell") == "true" ? true : false;
        this.couponBuyOrSell =
          url.searchParams.get("isSell") == "true" ? true : false;
        this.callBuyOrSell =
          url.searchParams.get("isSell") == "true" ? true : false;
        // this.maturitySell = url.searchParams.get("maturity") == "true" ?  true : false;
        // this.insuredBuyOrSell = url.searchParams.get("insured") == "true" ?  true : false;
        // this.moodyBuyOrSell = url.searchParams.get("moody") == "true" ?  true : false;
        // this.SPBuyOrSell = url.searchParams.get("SP") == "true" ?  true : false;
        // this.stateBuyOrSell = url.searchParams.get("state") == "true" ?  true : false;
        // this.insuranceBuyOrSell = url.searchParams.get("insurance") == "true" ?  true : false;
        // this.couponBuyOrSell = url.searchParams.get("coupon") == "true" ?  true : false;
        // this.callBuyOrSell = url.searchParams.get("call") == "true" ?  true : false;
        this.getPopupMaturityReportData();
        this.getInsuredReportData();
        this.getMoodyRatingReportData();
        this.getSPRatingReportData();
        this.getInsuranceReportData();
        //this.getPurposeReportData();
        //this.getPurposeReportDataWithGChart();
        this.getCouponReportData();
        this.getCallReportData();
        // fetch("https://unpkg.com/us-atlas/states-10m.json")
        //   .then(r => r.json())
        //   .then(us => {
        //     this.nation = topojson.feature(us, us.objects.nation).features[0];
        //     this.states = topojson.feature(us, us.objects.states).features;
        //     this.getStateReportData();
        //   });
        GoogleCharts.load(this.getStateReportData, {
          packages: ["geochart"],
          mapsApiKey: config.googleChartApiKey
        });
        GoogleCharts.load(this.getPurposeReportDataWithGChart, {
          packages: ["treemap"]
        });
        //alert("Token found");
      }
    });
  }
};
</script>
<style scoped>
.wrap {
  background: #fff;
  padding: 20px;
  width: 1000px;
  margin: 0 auto;
  text-align: center;
  position: relative;
}
.btn-print {
  position: fixed;
  right: 50px;
  top: 10px;
  border: 0;
  outline: none;
  background:#FF9E47;
  color:#fff;
}
#printPurpose {
  height: 400px !important;
}
.graphWrap {
  width: 80%;
  height: 40%;
  margin-bottom: 10%;
  margin: 0 auto;

}
.title {
  text-align: center;
  display: block;
  padding: 50px 0;
  font-weight:600;
}
h2 {
  color: #292929;
  text-align: center;
  padding-bottom: 15px;
}

@media print {
  @page { margin: 0;}
  .graphWrap { margin:15% auto; }
  .btn-print { display: none; }
  .wrap {text-align: center;}
  .title { padding:35px 0;}
  .page-brake { page-break-after: always; display: block; position: relative; }
  .page-brake img {position: fixed; left: 20px; bottom:20px;}
  /* .page-brake::after { 
    content:url(https://bidside-logos.s3.amazonaws.com/print_logo.png); 
    display: block; 
    width: 100px;
    position: fixed;
    bottom: 50px;
    left:0;
  } */
  .disclaimer { display: block; text-align: left; position: relative; bottom:60px; font-size: 11px; line-height: 13px;}
}
</style>